module.exports = __webpack_public_path__ + "static/img/lume_product.4a0fbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lume_product.png
// module id = fIJe
// module chunks = 1